//"whatwg-fetch" is module fot adapt fetch to IE
import { fetch as fetchPolyfill } from "whatwg-fetch";
import store from "../store";
import ErrorService from "./ErrorService";
import $ from "jquery";
import BaseService from "./BaseService";
import Utils from "../helpers/utils";

export default class AppService extends BaseService {
  static getInstance() {
    if (!this._instance) {
      this._instance = new AppService();
    }
    return this._instance;
  }

  async getEvents(url) {
    if (store.getters.isConnect == false) {
      Utils.log.info(
        "AppService: Not make getEvent ajax, because not connected"
      );
      return;
    }
    store.commit("increaseDecreasePolling", true);
    try {
      //let data = await this.performRequest(url, null, false);
      // change by Idan Tsoar 30.05.23 for showing errors on disconnect.
      let data = await this.performRequest(url);
      store.commit("increaseDecreasePolling", false);
      return data;
    } catch (e) {
      store.commit("setErrorResponseFromGetEvents", true);
    }
  }

  async joinChat(url, body) {
    try {
      let data = await this.performRequest(url, this.getDefaultPostObj(body));
      return data;
    } catch (e) {
      store.commit("setCaptchaPassed", false);
    }
  }

  async sendMessage(url, body) {
    return await this.performRequest(url, this.getDefaultPostObj(body));
  }

  async setTypingStatus(url, body) {
    try {
      return await this.performRequest(url, this.getDefaultPostObj(body));
    } catch(e) {}
  }

  leaveChat(url, body, objParam) {
    Utils.log.debug("on service leave chat..... ", JSON.stringify(body));

    //Use "$.ajax" instead "fetch", because of the 'async' option. (that needed in case of refresh (F5) the site)
    //sendBeacon is better, but doens't support on some brosers.

    if (!navigator.sendBeacon) {
      Utils.log.debug("navigator.sendBeacon not supported on this browser");
      return $.ajax({
        url: url,
        cache: false,
        type: "POST",
        data: JSON.stringify(body),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        async: objParam.isAsync, //needed in case of refresh the page
      })
        .done((res) => {
          Utils.log.debug(
            "on appService leaveChat success",
            JSON.stringify(res)
          );
          if (objParam.onSuccess) objParam.onSuccess(res);
        })
        .fail((jqXhr) => {
          Utils.log.error(
            "on appService leaveChat fail",
            JSON.stringify(jqXhr)
          );
          // ErrorService.displayAlert(jqXhr.statusText);
        });
    }
    Utils.log.debug("navigator.sendBeacon supported on this browser");
    navigator.sendBeacon(url, JSON.stringify(body));
  }

  async uploadFile(url, fd, headerToken) {
    // Widget data returns tenant, local data.zip has it inside
    var tenant = store.state.userTenant;
    if (!tenant) tenant = store.state.appData.JoinChatData.TenantID;
    var encoded = headerToken;
    var user = 'CustomChat'; // legacy default
    if (store.state.userIP) {
      var up = atob(encoded).split(':');
      if (up.length == 2) {
        user = store.state.userIP;
        encoded = btoa(user + ':' + up[1]);
      }
    }
    let myHeaders = {
        'Authorization': "Basic "+ encoded,
        "X-TenantID": tenant,
        "X-UserID": user,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        body: fd,
        withCredentials: true,
        headers: myHeaders,
      });
      const result = await response.json();
      return result;
    } catch (e) {
      ErrorService.displayAlert(e.message);
      throw new Error(e);
    }
  }
}
